import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ErrorTypes, MacAddressRequest, MacAddressResponse } from '../models/mac-address';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root'
})
export class MacAddressService {

  public readonly NOT_INVALID_NUMBER = 'errors.notInvalidNumber';
  public readonly NOT_FOUND_ERROR = 'errors.notFound';
  private readonly gUrl = environment.macBackendUrl + '/';
  private readonly translocoService = inject(TranslocoService);

  constructor(private http?: HttpClient) {
  }

  private createHeader(): HttpHeaders {
    let headers: HttpHeaders = new HttpHeaders();
    return headers;
  }

  public getMacAddresses(macAddressRequest: MacAddressRequest): Observable<MacAddressResponse[]> {
    const headers: HttpHeaders = this.createHeader();
    const url = `${this.gUrl}mac-address`;
    return this.http.post<MacAddressResponse[]>(url, macAddressRequest, { headers });
  }

  public createSerialNumberArray(serialNumbersString: any): string[] {
    const serialNumbers = this.replaceAllEnters(serialNumbersString);
    return this.removeDuplicates(MacAddressService.splitSerialnumber(serialNumbers));
  }

  public replaceAllEnters(serialNumbersString: any): string {
    return serialNumbersString.replace(/(\r\n|\n|\r)/gm, ',');
  }

  public prepareDataForCopyToClipboard(macAddresses: MacAddressResponse[]): string {
    return this.mapMacAddressesToString(macAddresses);
  }

  public prepareErrorMessage(value: ErrorTypes): string {
    return value === 'NOT_FOUND'
      ? this.translocoService.translate(this.NOT_FOUND_ERROR)
      : this.translocoService.translate(this.NOT_INVALID_NUMBER);
  }

  private static splitSerialnumber(serialNumbersString: any): string[] {
    const serialNumbers: string[] = serialNumbersString.replaceAll(' ', ',').split(',');
    return this.removeEmptyElements(serialNumbers);
  }

  private static removeEmptyElements(serialNumbers: string[]): string[] {
    return serialNumbers.filter((serialNumber => serialNumber !== ''));
  }

  private removeDuplicates(serialNumbers: string[]): string[] {
    let noDuplicatesSet = new Set<string>();
    serialNumbers.map((serialNumber) => noDuplicatesSet.add(serialNumber));
    return [...noDuplicatesSet];
  }

  private mapMacAddressesToString(macAddresses: MacAddressResponse[]): string {
    let textMacAddresses = '';
    macAddresses.map((macAddress) => {
      if (!macAddress?.error) {
        return textMacAddresses = textMacAddresses + macAddress.serialno + '\t' + macAddress.macaddress + '\n';
      }

      return textMacAddresses = textMacAddresses + macAddress.serialno + '\t' + this.prepareErrorMessage(macAddress.error) + '\n';

    });
    return textMacAddresses;
  }

}
